import * as i0 from '@angular/core';
import { EventEmitter, Component, ViewEncapsulation, Input, Output, ViewChild, HostListener, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@storeblocks/button-ng';
import { ButtonModule } from '@storeblocks/button-ng';
const _c0 = ["content"];
const _c1 = ["*"];
function ModalBaseComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵlistener("mousedown", function ModalBaseComponent_div_0_Template_div_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onOutsideCancelClick($event));
    });
    i0.ɵɵelementStart(1, "div", 3, 0);
    i0.ɵɵprojection(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("padding-top", ctx_r1.stickToTop ? ctx_r1.stickyPaddingTop : null);
    i0.ɵɵclassProp("rebrand", ctx_r1.rebrand)("sticktotop", ctx_r1.stickToTop);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("large", ctx_r1.large);
  }
}
const _c2 = ["ref"];
const _c3 = ["closeBtn"];
const _c4 = ["modalBase"];
const _c5 = [[["", "id", "modal-placeholder-1"]], "*", [["", "id", "modal-placeholder-2"]]];
const _c6 = ["#modal-placeholder-1", "*", "#modal-placeholder-2"];
function ModalComponent_h3_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("border", ctx_r1.rebrand ? false : ctx_r1.showBorder);
    i0.ɵɵattribute("aria-level", ctx_r1.headingLevel)("id", ctx_r1.getSafeIdString(ctx_r1.header));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.header, " ");
  }
}
function ModalComponent_p_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.ingress, " ");
  }
}
function ModalComponent_div_18_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵlistener("click", function ModalComponent_div_18_button_1_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onPrimaryClick($event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("stbButton", "contained")("colorVariant", ctx_r1.rebrand ? "darkRed" : "red")("disabled", ctx_r1.primaryButtonDisabled)("rebrand", ctx_r1.rebrand)("disabled", ctx_r1.primaryButtonDisabled)("enableSpinner", ctx_r1.isLoading)("iconType", ctx_r1.primaryIcon)("setIconBefore", ctx_r1.primaryIconBefore)("setIconAfter", ctx_r1.primaryIconAfter);
    i0.ɵɵattribute("data-trackid", ctx_r1.primaryTrackId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.primaryText, " ");
  }
}
function ModalComponent_div_18_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 20);
    i0.ɵɵlistener("click", function ModalComponent_div_18_button_2_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onCancelClick($event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r1.cancelButtonDisabled)("stbButton", "outlined")("rebrand", ctx_r1.rebrand)("colorVariant", ctx_r1.rebrand ? "darkRed" : "red")("iconType", ctx_r1.cancelIcon)("setIconBefore", ctx_r1.cancelIconBefore)("setIconAfter", ctx_r1.cancelIconAfter);
    i0.ɵɵattribute("data-trackid", ctx_r1.cancelTrackId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.cancelText);
  }
}
function ModalComponent_div_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, ModalComponent_div_18_button_1_Template, 2, 11, "button", 17)(2, ModalComponent_div_18_button_2_Template, 2, 9, "button", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("border", ctx_r1.rebrand ? false : ctx_r1.showBorder);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.primaryText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.cancelText);
  }
}
function DialogComponent_h3_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("id", ctx_r1.getSafeIdString(ctx_r1.header))("aria-level", ctx_r1.headingLevel);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.header, " ");
  }
}
function DialogComponent_p_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.ingress, " ");
  }
}
function DialogComponent_button_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 12);
    i0.ɵɵlistener("click", function DialogComponent_button_10_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onPrimaryClick($event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("stbButton", "contained")("rebrand", ctx_r1.rebrand)("colorVariant", ctx_r1.rebrand ? "darkRed" : "red")("enableSpinner", ctx_r1.isLoading)("disabled", ctx_r1.primaryButtonDisabled);
    i0.ɵɵattribute("data-trackid", ctx_r1.primaryTrackId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.primaryText);
  }
}
function DialogComponent_button_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵlistener("click", function DialogComponent_button_11_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onCancelClick($event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("stbButton", ctx_r1.rebrand ? "outlined" : "text")("rebrand", ctx_r1.rebrand)("colorVariant", ctx_r1.rebrand ? "darkRed" : "red")("setIconAfter", ctx_r1.rebrand ? false : true)("iconType", "arrow-right")("disabled", ctx_r1.cancelButtonDisabled);
    i0.ɵɵattribute("data-trackid", ctx_r1.cancelTrackId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.cancelText);
  }
}
let ModalBaseComponent = /*#__PURE__*/(() => {
  class ModalBaseComponent {
    constructor(renderer) {
      this.renderer = renderer;
      this.isShowing = false;
      this.large = false;
      this.forceClickOnButtons = false;
      this.rebrand = false;
      this.stickToTop = false;
      this.stickyPaddingTop = '10vh';
      this.disableBodyPadding = false; // temp escape-hatch for STOR-409 bug
      this.cancelEvent = new EventEmitter();
      // We grab the current overflow value from the DOM,
      // as early as possible. Revert back to the original
      // value when closing the modal.
      this.previousOverflowValue = '';
      this.previousPaddingRight = '';
    }
    ngOnDestroy() {
      // this might not run, but leave it just in case
      this.unlockBodyScroll();
    }
    ngOnChanges(changes) {
      // Take scrollbars and padding-right into account (STOR-341),
      // so that 100% width content does not jump around on the page
      if (changes?.isShowing?.currentValue) {
        const PR = window.getComputedStyle(document.querySelector('body')).getPropertyValue('padding-right');
        const scrollbarWidthBefore = window.innerWidth - document.documentElement.clientWidth;
        this.previousPaddingRight = document.body.style.paddingRight;
        this.previousOverflowValue = window.getComputedStyle(document.querySelector('body')).getPropertyValue('overflow');
        // if body has scrollbar we need to account for that
        if (scrollbarWidthBefore > 0 && this.disableBodyPadding === false) {
          this.renderer.setStyle(document.body, 'padding-right', `calc(${PR} + ${scrollbarWidthBefore}px)`);
        }
      }
      if (changes?.isShowing?.currentValue === true) {
        this.lockBodyScroll();
      }
      if (changes?.isShowing?.currentValue === false) {
        this.unlockBodyScroll();
      }
    }
    lockBodyScroll() {
      // Disable scrolling the background while modal is showing
      this.renderer.setStyle(document.body, 'overflow', 'hidden');
    }
    unlockBodyScroll() {
      // If computed overflow value is 'visible', unset it, as this is the default.
      // Avoids clobbering DOM unnessescarily.
      if (this.previousOverflowValue === 'visible') {
        this.renderer.removeStyle(document.body, 'overflow');
      } else {
        this.renderer.setStyle(document.body, 'overflow', this.previousOverflowValue);
      }
      if (this.disableBodyPadding === false) {
        this.renderer.setStyle(document.body, 'padding-right', this.previousPaddingRight);
      }
    }
    // Cancel on escape key pressed
    onKeydownHandler(event) {
      // do not fire events in closed state (GH issue #215)
      if (!this.isShowing) {
        return;
      }
      if (!this.forceClickOnButtons) {
        event.preventDefault();
        this.cancel();
      }
    }
    onCancelClick(event) {
      event.preventDefault();
      this.cancel();
    }
    // Cancel if clicked outside modal box
    onOutsideCancelClick(event) {
      if (event.target.classList.contains('stb-modal-base') && !this.forceClickOnButtons) {
        event.preventDefault();
        this.cancel();
      }
    }
    cancel() {
      this.isShowing = false;
      this.unlockBodyScroll();
      this.cancelEvent.emit();
    }
  }
  ModalBaseComponent.ɵfac = function ModalBaseComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ModalBaseComponent)(i0.ɵɵdirectiveInject(i0.Renderer2));
  };
  ModalBaseComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ModalBaseComponent,
    selectors: [["stb-modal-base"]],
    viewQuery: function ModalBaseComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 7);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.modalBox = _t.first);
      }
    },
    hostBindings: function ModalBaseComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("keydown.escape", function ModalBaseComponent_keydown_escape_HostBindingHandler($event) {
          return ctx.onKeydownHandler($event);
        }, false, i0.ɵɵresolveDocument);
      }
    },
    inputs: {
      isShowing: "isShowing",
      large: "large",
      forceClickOnButtons: "forceClickOnButtons",
      rebrand: "rebrand",
      stickToTop: "stickToTop",
      stickyPaddingTop: "stickyPaddingTop",
      disableBodyPadding: "disableBodyPadding"
    },
    outputs: {
      cancelEvent: "cancelEvent"
    },
    features: [i0.ɵɵNgOnChangesFeature],
    ngContentSelectors: _c1,
    decls: 1,
    vars: 1,
    consts: [["content", ""], ["class", "stb-modal-base", 3, "rebrand", "sticktotop", "padding-top", "mousedown", 4, "ngIf"], [1, "stb-modal-base", 3, "mousedown"], [1, "modal-content"]],
    template: function ModalBaseComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, ModalBaseComponent_div_0_Template, 4, 8, "div", 1);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.isShowing);
      }
    },
    dependencies: [i1.NgIf],
    styles: ["@font-face{font-family:SignaWeb-Book;src:url(https://assets.storebrand.no/fonts/Signa/SignaWeb-Book.woff) format(\"woff\");font-display:swap}@font-face{font-family:SignaWeb-Light;src:url(https://assets.storebrand.no/fonts/Signa/SignaWeb-Light.woff) format(\"woff\");font-display:swap}@font-face{font-family:Open Sans;font-style:normal;font-weight:400 700;font-variation-settings:\"wght\" 400 700;src:url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2 supports variations\"),url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2-variations\");font-display:swap}@font-face{font-family:Open Sans Semibold;font-style:normal;font-weight:600;font-variation-settings:\"wght\" 600;src:url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2 supports variations\"),url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2-variations\");font-display:swap}@font-face{font-family:Open Sans Bold;font-style:normal;font-weight:700;font-variation-settings:\"wght\" 700;src:url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2 supports variations\"),url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2-variations\");font-display:swap}@font-face{font-family:Storebrand Display;font-stretch:100%;font-style:normal;font-weight:400 700;font-display:swap;src:url(https://assets-t.storebrand.no/fonts/Storebrand/StorebrandDisplay.woff2) format(\"woff2\")}@font-face{font-family:Storebrand Text;font-style:normal;font-weight:400 700;font-stretch:100%;font-display:swap;src:url(https://assets-t.storebrand.no/fonts/Storebrand/StorebrandText.woff2) format(\"woff2\")}.stb-modal-base.rebrand[_ngcontent-%COMP%]{font-family:Storebrand Text,sans-serif}.stb-modal-base.rebrand[_ngcontent-%COMP%]   .modal-content[_ngcontent-%COMP%]{border-radius:16px;color:#700}.stb-modal-base[_ngcontent-%COMP%]{font-family:Open Sans,sans-serif;position:fixed;z-index:9999;left:0;top:0;width:100%;height:100%;overflow:auto;background-color:#19191999;display:flex;align-items:center}.stb-modal-base.sticktotop[_ngcontent-%COMP%]{display:block}.stb-modal-base[_ngcontent-%COMP%]   .modal-content[_ngcontent-%COMP%]{line-height:normal;background-color:#fff;min-width:288px;max-width:672px;box-shadow:0 0 15px #00000040;border-radius:4px;margin:auto}.stb-modal-base[_ngcontent-%COMP%]   .modal-content.large[_ngcontent-%COMP%]{width:100%}@media print{.stb-modal-base[_ngcontent-%COMP%]   .modal-content[_ngcontent-%COMP%]{max-width:none;margin:10px}}"]
  });
  return ModalBaseComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// Utils used by both modal and dialog components
// replace any non-word with underscore for use in id attr
// TODO: using random number in here causes expressionChanged errors
function getSafeIdString(input) {
  // const rand = Math.floor(Math.random() * 999999);
  if (input) {
    return 'stb-modal--' + input.replace(/\W/g, '_').toLocaleLowerCase(); // + rand;
  }
}
function setAriaAttrsOnTrigger(triggerElem) {
  // try to add missing aria attributes
  if (!triggerElem) {
    return;
  }
  // don't overwrite if already present
  if (triggerElem.getAttribute('aria-haspopup') === null) {
    triggerElem.setAttribute('aria-haspopup', 'dialog');
  }
}
function focusOnTrigger(triggerElem) {
  if (triggerElem != null && triggerElem) {
    triggerElem.focus();
  }
}
function focusTrapFn(firstFocusableEl, lastFocusableEl, e) {
  const isTabPressed = e.key === 'Tab';
  if (!isTabPressed) {
    return;
  }
  /* shift + tab */
  if (e.shiftKey) {
    if (document.activeElement === firstFocusableEl) {
      lastFocusableEl.focus();
      e.preventDefault();
    }
  } else {
    /* tab */
    if (document.activeElement === lastFocusableEl) {
      firstFocusableEl.focus();
      e.preventDefault();
    }
  }
}
let listenerProxy; // used to remove eventHandler later on
function setupFocusTrap(ref) {
  // https://hidde.blog/using-javascript-to-trap-focus-in-an-element/
  const focusableSelectors = ['a[href]:not([disabled])', 'button:not([disabled])', 'textarea:not([disabled])', 'input[type="text"]:not([disabled])', 'input[type="radio"]:not([disabled])', 'input[type="checkbox"]:not([disabled])', 'select:not([disabled])'];
  const focusableEls = ref.nativeElement.querySelectorAll(focusableSelectors.join(', '));
  const firstFocusableEl = focusableEls[0];
  const lastFocusableEl = focusableEls[focusableEls.length - 1];
  // use this trick to be able to removeEventListener later,
  // by using 'listenerProxy' variable as reference
  listenerProxy = focusTrapFn.bind(null, firstFocusableEl, lastFocusableEl);
  ref.nativeElement.addEventListener('keydown', listenerProxy);
}
function removeFocusTrap(ref) {
  ref.nativeElement.removeEventListener('keydown', listenerProxy);
}
let ModalComponent = /*#__PURE__*/(() => {
  class ModalComponent {
    constructor() {
      this.triggerId = '';
      this.isShowing = false;
      this.primaryText = 'Ok';
      this.primaryIconBefore = false;
      this.primaryIconAfter = false;
      this.cancelIconBefore = false;
      this.cancelIconAfter = false;
      this.large = false;
      this.showButtons = true;
      this.showBorder = true;
      this.headingLevel = 3;
      this.stickToTop = false;
      this.stickyPaddingTop = '10vh';
      this.isLoading = false;
      this.cancelButtonDisabled = false;
      this.forceClickOnButtons = false; // passed down to modal-base
      /**
       * @description If true, removes margins from p-tags via ng-content in the modal
       * @type {boolean}
       * @default false
       */
      this.noPMargins = false;
      this.rebrand = false;
      this.disableBodyPadding = false; // temp escape-hatch for STOR-409 bug
      this.primaryClick = new EventEmitter();
      this.cancelClick = new EventEmitter();
      this.getSafeIdString = getSafeIdString;
    }
    ngOnInit() {
      if (this.header === undefined) {
        console.warn('[stb-modal]: header is required');
      }
      // trim any whitespace as it causes layout issues
      this.primaryText = this.primaryText?.trim();
      this.cancelText = this.cancelText?.trim();
    }
    ngAfterViewInit() {
      setupFocusTrap(this.ref);
      this.triggerElem = document.getElementById(this.triggerId);
      setAriaAttrsOnTrigger(this.triggerElem);
    }
    ngOnChanges(changes) {
      // update aria-expanded accordingly
      if (this.triggerElem && changes.isShowing) {
        this.triggerElem.setAttribute('aria-expanded', changes.isShowing.currentValue);
      }
      // set focus on modal when opening it
      if (changes.isShowing?.previousValue === false && changes.isShowing?.currentValue === true) {
        setTimeout(() => {
          this.closeBtn.nativeElement.focus();
        });
      }
      // make sure we unlock body scroll if isShowing input changes (not clicking on buttons):
      if (changes.isShowing && changes.isShowing.currentValue === false && this.modalBase) {
        this.modalBase.unlockBodyScroll();
      }
    }
    ngOnDestroy() {
      // remove eventListener for focustrap
      removeFocusTrap(this.ref);
    }
    onPrimaryClick(event) {
      event.preventDefault();
      this.modalBase.unlockBodyScroll();
      this.primaryClick.emit();
      focusOnTrigger(this.triggerElem);
    }
    onCancelClick(event) {
      if (event !== undefined) {
        event.preventDefault();
      }
      this.modalBase.unlockBodyScroll();
      this.cancelClick.emit();
      focusOnTrigger(this.triggerElem);
    }
    closeIconClicked(event) {
      if (this.cancelButtonDisabled) {
        return;
      }
      this.modalBase.unlockBodyScroll();
      this.cancelClick.emit();
      focusOnTrigger(this.triggerElem);
    }
  }
  ModalComponent.ɵfac = function ModalComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ModalComponent)();
  };
  ModalComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ModalComponent,
    selectors: [["stb-modal"]],
    viewQuery: function ModalComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c2, 7);
        i0.ɵɵviewQuery(_c3, 7);
        i0.ɵɵviewQuery(_c4, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ref = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.closeBtn = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.modalBase = _t.first);
      }
    },
    inputs: {
      triggerId: "triggerId",
      isShowing: "isShowing",
      header: "header",
      ingress: "ingress",
      primaryText: "primaryText",
      primaryIcon: "primaryIcon",
      primaryIconBefore: "primaryIconBefore",
      primaryIconAfter: "primaryIconAfter",
      primaryTrackId: "primaryTrackId",
      primaryButtonDisabled: "primaryButtonDisabled",
      cancelText: "cancelText",
      cancelIcon: "cancelIcon",
      cancelIconBefore: "cancelIconBefore",
      cancelIconAfter: "cancelIconAfter",
      cancelTrackId: "cancelTrackId",
      large: "large",
      showButtons: "showButtons",
      showBorder: "showBorder",
      headingLevel: "headingLevel",
      stickToTop: "stickToTop",
      stickyPaddingTop: "stickyPaddingTop",
      isLoading: "isLoading",
      cancelButtonDisabled: "cancelButtonDisabled",
      forceClickOnButtons: "forceClickOnButtons",
      noPMargins: "noPMargins",
      rebrand: "rebrand",
      disableBodyPadding: "disableBodyPadding"
    },
    outputs: {
      primaryClick: "primaryClick",
      cancelClick: "cancelClick"
    },
    features: [i0.ɵɵNgOnChangesFeature],
    ngContentSelectors: _c6,
    decls: 19,
    vars: 18,
    consts: [["modalBase", ""], ["ref", ""], ["closeBtn", ""], [1, "stb-modal", 3, "cancelEvent", "large", "isShowing", "rebrand", "stickToTop", "stickyPaddingTop", "disableBodyPadding", "forceClickOnButtons"], ["role", "dialog", "tabindex", "-1", 1, "internal"], [1, "header"], [1, "close-icon"], [3, "click", "disabled"], [1, "icon-xsmall"], [3, "border", 4, "ngIf"], [1, "content"], ["class", "ingress", 4, "ngIf"], [1, "placeholder-1"], [1, "placeholder-2"], ["class", "footer", 3, "border", 4, "ngIf"], [1, "ingress"], [1, "footer"], ["class", "contained-btn", 3, "stbButton", "colorVariant", "disabled", "rebrand", "enableSpinner", "iconType", "setIconBefore", "setIconAfter", "click", 4, "ngIf"], ["class", "cancel", 3, "disabled", "stbButton", "rebrand", "colorVariant", "iconType", "setIconBefore", "setIconAfter", "click", 4, "ngIf"], [1, "contained-btn", 3, "click", "stbButton", "colorVariant", "disabled", "rebrand", "enableSpinner", "iconType", "setIconBefore", "setIconAfter"], [1, "cancel", 3, "click", "disabled", "stbButton", "rebrand", "colorVariant", "iconType", "setIconBefore", "setIconAfter"]],
    template: function ModalComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵprojectionDef(_c5);
        i0.ɵɵelementStart(0, "stb-modal-base", 3, 0);
        i0.ɵɵlistener("cancelEvent", function ModalComponent_Template_stb_modal_base_cancelEvent_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.onCancelClick($event));
        });
        i0.ɵɵelementStart(2, "div", 4, 1)(4, "div", 5)(5, "div", 6)(6, "button", 7, 2);
        i0.ɵɵlistener("click", function ModalComponent_Template_button_click_6_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.closeIconClicked($event));
        });
        i0.ɵɵelementStart(8, "i", 8);
        i0.ɵɵtext(9, "close");
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(10, ModalComponent_h3_10_Template, 2, 5, "h3", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 10);
        i0.ɵɵtemplate(12, ModalComponent_p_12_Template, 2, 1, "p", 11);
        i0.ɵɵelementStart(13, "div", 12);
        i0.ɵɵprojection(14);
        i0.ɵɵelementEnd();
        i0.ɵɵprojection(15, 1);
        i0.ɵɵelementStart(16, "div", 13);
        i0.ɵɵprojection(17, 2);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(18, ModalComponent_div_18_Template, 3, 4, "div", 14);
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵclassProp("rebrand", ctx.rebrand);
        i0.ɵɵproperty("large", ctx.large)("isShowing", ctx.isShowing)("rebrand", ctx.rebrand)("stickToTop", ctx.stickToTop)("stickyPaddingTop", ctx.stickyPaddingTop)("disableBodyPadding", ctx.disableBodyPadding)("forceClickOnButtons", ctx.forceClickOnButtons);
        i0.ɵɵadvance(2);
        i0.ɵɵclassProp("no-p-margins", ctx.noPMargins);
        i0.ɵɵattribute("aria-labelledby", ctx.getSafeIdString(ctx.header))("aria-describedby", ctx.getSafeIdString(ctx.header) + "-content");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("disabled", ctx.cancelButtonDisabled);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.header);
        i0.ɵɵadvance();
        i0.ɵɵattribute("id", ctx.getSafeIdString(ctx.header) + "-content");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.ingress);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.showButtons);
      }
    },
    dependencies: [i1.NgIf, i2.StbButtonDirective, i2.ButtonComponent, ModalBaseComponent],
    styles: ["@font-face{font-family:System-Icons;src:url(https://assets.storebrand.no/fonts/System-Icons/System-Icons.eot) format(\"eot\"),url(https://assets.storebrand.no/fonts/System-Icons/System-Icons.woff) format(\"woff\"),url(https://assets.storebrand.no/fonts/System-Icons/System-Icons.woff2) format(\"wolf2\"),url(https://assets.storebrand.no/fonts/System-Icons/System-Icons.ttf) format(\"truetype\");text-rendering:optimizeLegibility}@font-face{font-family:Storebrand Symbols;src:url(https://assets.storebrand.no/fonts/Symbols/StorebrandSymbols.eot) format(\"eot\"),url(https://assets.storebrand.no/fonts/Symbols/StorebrandSymbols.woff) format(\"woff\"),url(https://assets.storebrand.no/fonts/Symbols/StorebrandSymbols.woff2) format(\"wolf2\"),url(https://assets.storebrand.no/fonts/Symbols/StorebrandSymbols.ttf) format(\"truetype\");text-rendering:optimizeLegibility}i.symbol[_ngcontent-%COMP%]{font-family:Storebrand Symbols!important}i[_ngcontent-%COMP%]{font-family:System-Icons!important;font-style:normal;font-weight:400!important;font-size:16px;line-height:16px;white-space:nowrap;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}i[_ngcontent-%COMP%]:empty:not([class*=system-icon]){display:inline-flex;width:24px;height:24px;background:var(--color-primary)}.icon-xsmall[_ngcontent-%COMP%]{font-size:16px!important;line-height:16px!important}.icon-small[_ngcontent-%COMP%]{font-size:20px!important;line-height:20px!important}.icon-medium[_ngcontent-%COMP%]{font-size:24px!important;line-height:24px!important}.icon-large[_ngcontent-%COMP%]{font-size:32px!important;line-height:32px!important}.stb-modal.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]{padding:32px}.stb-modal.rebrand[_ngcontent-%COMP%]   .modal-content[_ngcontent-%COMP%]{transition-property:height;transition:cubic-bezier(.175,.885,.32,1) .1s}.stb-modal.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%], .stb-modal.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%], .stb-modal.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%], .stb-modal.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%], .stb-modal.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%], .stb-modal.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{font-family:Storebrand Display,sans-serif;font-size:2rem;font-weight:600;line-height:2.5rem;color:var(--p-color-text-primary, #560000);padding-bottom:0;margin-bottom:16px;border-bottom:none}.stb-modal.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{padding-bottom:0}.stb-modal.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   p.ingress[_ngcontent-%COMP%]{font-family:Storebrand Text,sans-serif;color:var(--p-color-text-primary, #560000);line-height:1.5;font-size:1.125rem;font-weight:400}.stb-modal.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]     p{color:var(--p-color-text-primary, #560000);font-family:Storebrand Text,sans-serif;font-size:1.125rem;line-height:1.5;margin-bottom:0}.stb-modal.rebrand[_ngcontent-%COMP%]   .internal.no-p-margins[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]     p{margin:0}.stb-modal.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]{display:flex}.stb-modal.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]   .stb-btn-contained[_ngcontent-%COMP%]:first-child, .stb-modal.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin-bottom:0}.stb-modal.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]   button[_ngcontent-%COMP%] + button[_ngcontent-%COMP%]{margin-left:8px}.stb-modal.rebrand[_ngcontent-%COMP%]   .close-icon[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:focus-visible{border-radius:4px}.stb-modal.rebrand[_ngcontent-%COMP%]   .close-icon[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{color:var(--p-color-red-800, #770000)}@media screen and (max-width: 768px){.stb-modal.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%], .stb-modal.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%], .stb-modal.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%], .stb-modal.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%], .stb-modal.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%], .stb-modal.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{font-size:1.5rem}.stb-modal.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   p.ingress[_ngcontent-%COMP%]{font-size:1rem}.stb-modal.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]     p{font-size:1rem}}.stb-modal[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]{padding:32px 32px 16px}.stb-modal[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]{background-color:#fff}.stb-modal[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .close-icon[_ngcontent-%COMP%]{float:right;position:relative;top:5px;cursor:pointer}.stb-modal[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .close-icon[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{padding:0;background:none;border:none}.stb-modal[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .close-icon[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:focus{outline:2px solid #00f;outline-offset:4px}.stb-modal[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .close-icon[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:focus:not(:focus-visible){outline:0}.stb-modal[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .close-icon[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:focus-visible{outline:2px solid #00f;outline-offset:4px}.stb-modal[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .close-icon[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{cursor:pointer}.stb-modal[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{font-family:Open Sans;font-size:18px;line-height:24px;font-weight:700;margin-top:0;padding-bottom:36px;margin-bottom:24px;border-bottom:none}.stb-modal[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   h3.border[_ngcontent-%COMP%]{border-bottom:1px solid #e6e6e6}.stb-modal[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{overflow:auto;max-height:calc(80vh - 8rem);padding-bottom:12px}.stb-modal[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]     p{margin:18px 0;word-wrap:break-word;font-size:16px;line-height:24px}.stb-modal[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   p.ingress[_ngcontent-%COMP%]{margin-top:0;font-size:18px;line-height:24px}@media print{.stb-modal[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{max-height:none}}.stb-modal[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{box-sizing:border-box;background-position:0% 0%,0px 100%,0% 0%,0px 100%;background-image:linear-gradient(white 30%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),white 70%),radial-gradient(farthest-side at 50% 0px,rgba(0,0,0,.2),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,rgba(0,0,0,.2),rgba(0,0,0,0));background-origin:padding-box,padding-box,padding-box,padding-box;background-clip:border-box,border-box,border-box,border-box;background-repeat:no-repeat;background-color:#fff;background-size:100% 40px,100% 40px,100% 14px,100% 14px;background-attachment:local,local,scroll,scroll}.stb-modal[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]{display:flex;border-top:none;padding-top:24px}.stb-modal[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]   .stb-btn-contained[_ngcontent-%COMP%]{word-wrap:break-word}.stb-modal[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]   .stb-btn-contained[_ngcontent-%COMP%]:first-child, .stb-modal[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]   .stb-btn-outlined[_ngcontent-%COMP%]{margin-bottom:16px}.stb-modal[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .footer.border[_ngcontent-%COMP%]{border-top:1px solid #e6e6e6}@media print{.close-icon[_ngcontent-%COMP%]{display:none}}"]
  });
  return ModalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DialogComponent = /*#__PURE__*/(() => {
  class DialogComponent {
    constructor() {
      this.triggerId = '';
      this.isShowing = false;
      this.large = false;
      this.forceClickOnButtons = false;
      this.headingLevel = 3;
      this.isLoading = false;
      this.cancelButtonDisabled = false;
      this.rebrand = false;
      this.primaryClick = new EventEmitter();
      this.cancelClick = new EventEmitter();
      this.getSafeIdString = getSafeIdString;
    }
    // Ok on enter key pressed
    onKeydownHandler(event) {
      // make sure we're not hijacking the button event emitters
      if (!this.forceClickOnButtons && this.isShowing && event.target.nodeName !== 'BUTTON') {
        event.preventDefault();
        this.modalBase.unlockBodyScroll();
        this.primaryClick.emit();
        focusOnTrigger(this.triggerElem);
      }
    }
    ngOnInit() {
      // trim any whitespace as it causes layout issues
      this.primaryText = this.primaryText?.trim();
      this.cancelText = this.cancelText?.trim();
      if (this.header === undefined) {
        console.warn('[stb-dialog]: header is required');
      }
    }
    ngOnChanges(changes) {
      // update aria-expanded accordingly
      if (this.triggerElem && changes.isShowing) {
        this.triggerElem.setAttribute('aria-expanded', changes.isShowing.currentValue);
      }
      // set focus on modal when opening it
      if (changes.isShowing?.previousValue === false && changes.isShowing?.currentValue === true) {
        setTimeout(() => {
          const firstButton = this.ref.nativeElement.querySelectorAll('button')[0];
          if (firstButton) {
            firstButton.focus();
          }
        });
      }
      // make sure we unlock body scroll if isShowing input changes (not clicking on buttons):
      if (changes.isShowing && changes.isShowing.currentValue === false && this.modalBase) {
        this.modalBase.unlockBodyScroll();
      }
    }
    ngAfterViewInit() {
      setupFocusTrap(this.ref);
      this.triggerElem = document.getElementById(this.triggerId);
      setAriaAttrsOnTrigger(this.triggerElem);
    }
    onPrimaryClick(event) {
      event.preventDefault();
      this.modalBase.unlockBodyScroll();
      this.primaryClick.emit();
      focusOnTrigger(this.triggerElem);
    }
    onCancelClick(event) {
      if (event) {
        event.preventDefault();
      }
      if (this.cancelButtonDisabled) {
        return;
      }
      this.modalBase.unlockBodyScroll();
      this.cancelClick.emit();
      focusOnTrigger(this.triggerElem);
    }
  }
  DialogComponent.ɵfac = function DialogComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DialogComponent)();
  };
  DialogComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DialogComponent,
    selectors: [["stb-dialog"]],
    viewQuery: function DialogComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c2, 7);
        i0.ɵɵviewQuery(_c4, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ref = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.modalBase = _t.first);
      }
    },
    hostBindings: function DialogComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("keydown.enter", function DialogComponent_keydown_enter_HostBindingHandler($event) {
          return ctx.onKeydownHandler($event);
        }, false, i0.ɵɵresolveDocument);
      }
    },
    inputs: {
      triggerId: "triggerId",
      isShowing: "isShowing",
      header: "header",
      ingress: "ingress",
      primaryText: "primaryText",
      primaryTrackId: "primaryTrackId",
      primaryButtonDisabled: "primaryButtonDisabled",
      cancelText: "cancelText",
      cancelTrackId: "cancelTrackId",
      large: "large",
      forceClickOnButtons: "forceClickOnButtons",
      headingLevel: "headingLevel",
      isLoading: "isLoading",
      cancelButtonDisabled: "cancelButtonDisabled",
      rebrand: "rebrand"
    },
    outputs: {
      primaryClick: "primaryClick",
      cancelClick: "cancelClick"
    },
    features: [i0.ɵɵNgOnChangesFeature],
    ngContentSelectors: _c1,
    decls: 12,
    vars: 14,
    consts: [["modalBase", ""], ["ref", ""], [1, "stb-dialog", 3, "cancelEvent", "forceClickOnButtons", "rebrand", "large", "isShowing"], ["role", "dialog", "tabindex", "-1", 1, "internal"], [1, "header"], [4, "ngIf"], [1, "content"], ["class", "ingress", 4, "ngIf"], [1, "footer"], ["class", "contained-btn", 3, "stbButton", "rebrand", "colorVariant", "enableSpinner", "disabled", "click", 4, "ngIf"], ["class", "cancel", 3, "stbButton", "rebrand", "colorVariant", "setIconAfter", "iconType", "disabled", "click", 4, "ngIf"], [1, "ingress"], [1, "contained-btn", 3, "click", "stbButton", "rebrand", "colorVariant", "enableSpinner", "disabled"], [1, "cancel", 3, "click", "stbButton", "rebrand", "colorVariant", "setIconAfter", "iconType", "disabled"]],
    template: function DialogComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "stb-modal-base", 2, 0);
        i0.ɵɵlistener("cancelEvent", function DialogComponent_Template_stb_modal_base_cancelEvent_0_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.onCancelClick(undefined));
        });
        i0.ɵɵelementStart(2, "div", 3, 1)(4, "div", 4);
        i0.ɵɵtemplate(5, DialogComponent_h3_5_Template, 2, 3, "h3", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵtemplate(7, DialogComponent_p_7_Template, 2, 1, "p", 7);
        i0.ɵɵprojection(8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 8);
        i0.ɵɵtemplate(10, DialogComponent_button_10_Template, 2, 7, "button", 9)(11, DialogComponent_button_11_Template, 2, 8, "button", 10);
        i0.ɵɵelementEnd()()();
      }
      if (rf & 2) {
        i0.ɵɵclassProp("rebrand", ctx.rebrand);
        i0.ɵɵproperty("forceClickOnButtons", ctx.forceClickOnButtons)("rebrand", ctx.rebrand)("large", ctx.large)("isShowing", ctx.isShowing)("forceClickOnButtons", ctx.forceClickOnButtons);
        i0.ɵɵadvance(2);
        i0.ɵɵattribute("aria-labelledby", ctx.getSafeIdString(ctx.header))("aria-describedby", ctx.getSafeIdString(ctx.header) + "-content");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.header);
        i0.ɵɵadvance();
        i0.ɵɵattribute("id", ctx.getSafeIdString(ctx.header) + "-content");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.ingress);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.primaryText);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.cancelText);
      }
    },
    dependencies: [i1.NgIf, i2.StbButtonDirective, i2.ButtonComponent, ModalBaseComponent],
    styles: [".stb-dialog.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]{padding:32px}.stb-dialog.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%], .stb-dialog.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%], .stb-dialog.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%], .stb-dialog.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%], .stb-dialog.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%], .stb-dialog.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{font-family:Storebrand Text,sans-serif;font-size:2rem;font-weight:600;line-height:1.5;color:var(--p-color-text-primary, #560000);padding-bottom:0;margin-bottom:16px;border-bottom:none}.stb-dialog.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   p.ingress[_ngcontent-%COMP%]{color:var(--p-color-text-primary, #560000);font-family:inherit;font-size:1.125rem;line-height:1.5;margin:0}.stb-dialog.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]{margin-top:24px}.stb-dialog.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]   .stb-btn-contained[_ngcontent-%COMP%]:first-child, .stb-dialog.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin-bottom:0}.stb-dialog.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]   button[_ngcontent-%COMP%] + button[_ngcontent-%COMP%]{margin-left:8px}@media screen and (max-width: 768px){.stb-dialog.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%], .stb-dialog.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%], .stb-dialog.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%], .stb-dialog.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%], .stb-dialog.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%], .stb-dialog.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{font-size:1.25rem}.stb-dialog.rebrand[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   p.ingress[_ngcontent-%COMP%]{font-size:1rem}}.stb-dialog[_ngcontent-%COMP%]     .stb-modal-base .modal-content{max-width:560px!important;min-width:288px!important;box-shadow:0 0 15px #00000040}.stb-dialog[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]{padding:32px 32px 16px}.stb-dialog[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]{background-color:#fff}.stb-dialog[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{font-family:Open Sans;font-weight:700;font-size:18px;line-height:24px;margin:0}.stb-dialog[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{overflow:auto;max-height:80vh;min-height:-moz-fit-content;min-height:fit-content}.stb-dialog[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   p.ingress[_ngcontent-%COMP%]{font-size:16px;line-height:24px;margin-bottom:16px;margin-top:16px}@media print{.stb-dialog[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{max-height:none}}.stb-dialog[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]{margin-top:16px}.stb-dialog[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]   .stb-btn-contained[_ngcontent-%COMP%]{word-wrap:break-word}.stb-dialog[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]   .stb-btn-contained[_ngcontent-%COMP%]:first-child, .stb-dialog[_ngcontent-%COMP%]   .internal[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]   .stb-btn-outlined[_ngcontent-%COMP%]{margin-bottom:16px}"]
  });
  return DialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModalModule = /*#__PURE__*/(() => {
  class ModalModule {}
  ModalModule.ɵfac = function ModalModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ModalModule)();
  };
  ModalModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: ModalModule
  });
  ModalModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule, ButtonModule]
  });
  return ModalModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of modal
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DialogComponent, ModalBaseComponent, ModalComponent, ModalModule };
